
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';
import FAQ from './FAQ';
import GoogleTagManager from '../components/GoogleTagManager';


function Surattomumbaiairporttaxi() {



    const cardData =
    {
        keyword: ' Surat to Mumbai Airport Taxi',
        heading: 'Deva Cabs: Surat to Mumbai Airport Taxi  ',
        headingDescription: 'Deva Cabs provides reliable and convenient taxi services from Surat to Mumbai Airport, ideal for business travelers, families, and outstation commuters. Covering a distance of around 280 km, our taxis ensure a smooth and timely ride in well-maintained vehicles with professional drivers. Whether you prefer a Sedan, SUV, or Innova Crysta, we offer 24/7 pickups, fixed fares, and a comfortable travel experience from your doorstep in Surat to Mumbai Airport terminals.',

        top: 'Top Places to Visit in Mumbai with Deva Cabs',

"topPlaces": [
  {
    "title": "Gateway of India",
    "location": "Mumbai, Maharashtra",
    "description": "The Gateway of India is Mumbai’s most iconic monument, built in 1924 to commemorate the visit of King George V and Queen Mary. Overlooking the Arabian Sea and standing beside the Taj Mahal Palace Hotel, it is a popular starting point for ferry rides to Elephanta Caves and a must-visit historical attraction that symbolizes Mumbai’s colonial past and vibrant present."
  },
  {
    "title": "Marine Drive",
    "location": "Mumbai, Maharashtra",
    "description": "Marine Drive is a 3.6 km-long boulevard that curves along the coast from Nariman Point to Girgaon Chowpatty. Nicknamed the 'Queen’s Necklace' for its glittering lights at night, it's a favorite spot for peaceful walks, sunset views, and soaking in the coastal breeze with the city skyline as a backdrop."
  },
  {
    "title": "Elephanta Caves",
    "location": "Elephanta Island, Mumbai Harbour",
    "description": "A UNESCO World Heritage Site, Elephanta Caves are a group of ancient rock-cut temples located on Elephanta Island. Accessible via ferry from the Gateway of India, the caves date back to the 5th–8th centuries and are famous for intricate carvings of Lord Shiva, especially the iconic Trimurti sculpture."
  },
  {
    "title": "Siddhivinayak Temple",
    "location": "Prabhadevi, Mumbai, Maharashtra",
    "description": "Dedicated to Lord Ganesha, the Siddhivinayak Temple is one of Mumbai’s most important spiritual centers. Known for its majestic architecture and the black stone idol with a trunk curving to the right, the temple attracts devotees from all walks of life, especially on Tuesdays when thousands come for darshan."
  },
  {
    "title": "Chhatrapati Shivaji Maharaj Terminus",
    "location": "Mumbai, Maharashtra",
    "description": "A UNESCO World Heritage Site, this historic railway station is an architectural marvel that combines Victorian Gothic with traditional Indian design. Built in 1887, it remains a bustling transport hub and a monument that reflects Mumbai's colonial legacy and artistic grandeur."
  },
  {
    "title": "Juhu Beach",
    "location": "Mumbai, Maharashtra",
    "description": "Juhu Beach is a lively stretch of coastline known for its street food stalls, Bollywood celebrity homes, and sunset views. From children playing cricket to couples strolling by the waves, the beach buzzes with energy and offers a quintessential Mumbai experience with snacks like vada pav and bhel puri."
  },
  {
    "title": "Haji Ali Dargah",
    "location": "Worli, Mumbai, Maharashtra",
    "description": "Situated on an islet off the coast of Worli, Haji Ali Dargah is a 15th-century Indo-Islamic shrine housing the tomb of Sufi saint Haji Ali Shah Bukhari. Accessible by a narrow causeway during low tide, the dargah offers spiritual tranquility along with breathtaking sea views."
  },
  {
    "title": "Sanjay Gandhi National Park",
    "location": "Borivali, Mumbai, Maharashtra",
    "description": "One of the world’s few national parks within city limits, Sanjay Gandhi National Park is a green haven offering nature trails, a toy train, boating, and wildlife like leopards and deer. The park is also home to the ancient Kanheri Caves, which showcase Buddhist rock-cut architecture dating back over 2,000 years."
  },
  {
    "title": "Chor Bazaar",
    "location": "Bhendi Bazaar, Mumbai, Maharashtra",
    "description": "One of India’s oldest flea markets, Chor Bazaar is a treasure trove of antiques, vintage Bollywood posters, rare coins, and quirky collectibles. Despite its name meaning 'Thieves’ Market', it’s a legal and lively destination for bargain hunters and curious tourists alike."
  },
  {
    "title": "Girgaon Chowpatty",
    "location": "Girgaon, Mumbai, Maharashtra",
    "description": "Located at the northern end of Marine Drive, Girgaon Chowpatty is a city beach known for its festive spirit, street food, and cultural gatherings. It becomes especially vibrant during Ganesh Chaturthi, when thousands gather for idol immersions in the Arabian Sea."
  }
],



"services": [
  {
    "name": "Surat to Mumbai Airport Taxi",
    "description": "Deva Cabs offers reliable and comfortable taxi services from Surat to Mumbai Airport, ensuring a hassle-free transfer for both business and leisure travelers. Our well-maintained fleet includes air-conditioned vehicles with ample space for passengers and luggage. Whether you’re catching an early morning flight or returning after a long trip, our professional drivers guarantee timely pickups and smooth rides, making your journey stress-free and pleasant."
  },
  {
    "name": "One-way taxi Surat to Mumbai Airport",
    "description": "Opt for our convenient one-way taxi service from Surat to Mumbai Airport, designed to provide a cost-effective and straightforward travel option. Deva Cabs offers fixed pricing with no hidden charges, allowing you to book with confidence. Our experienced chauffeurs navigate the best routes for a quick and safe journey, ensuring you reach Mumbai Airport well in time for your flight."
  },
  {
    "name": "Cab booking Surat to Mumbai Airport",
    "description": "Booking a cab from Surat to Mumbai Airport is now effortless with Deva Cabs. Use our online platform or call us to reserve your vehicle instantly. Choose from a variety of cars including sedans, SUVs, and luxury options, all driven by courteous and professional drivers. We prioritize your comfort and punctuality, ensuring you experience seamless airport transfers every time."
  },
  {
    "name": "Affordable Surat to Mumbai Airport cab",
    "description": "Looking for budget-friendly taxi services from Surat to Mumbai Airport? Deva Cabs offers affordable cab options without compromising on comfort or safety. Our economical vehicles are well-maintained and air-conditioned, perfect for solo travelers and small groups. Transparent pricing and no hidden fees make our service a top choice for those seeking value and reliability."
  },
  {
    "name": "SUV taxi Surat to Mumbai Airport",
    "description": "Travel spaciously and comfortably with our SUV taxi service from Surat to Mumbai Airport. Our fleet includes popular models like Toyota Innova and Mahindra XUV, offering plenty of legroom, reclining seats, and ample luggage space. Ideal for families or groups traveling with extra baggage, these vehicles ensure a smooth and pleasant journey all the way to Mumbai Airport."
  },
  {
    "name": "Luxury car Surat to Mumbai Airport",
    "description": "Experience premium travel with our luxury car rentals from Surat to Mumbai Airport. Deva Cabs offers high-end vehicles equipped with plush interiors, advanced climate control, and modern amenities. Our chauffeurs provide discreet, professional service ensuring a comfortable and stylish transfer ideal for corporate clients and special occasions."
  },
  {
    "name": "Surat to Mumbai Airport drop service",
    "description": "Our reliable drop service from Surat to Mumbai Airport ensures timely and hassle-free transfers. Whether you’re headed to the domestic or international terminal, Deva Cabs guarantees door-to-door service with experienced drivers who are well-versed in airport protocols and traffic conditions. We help you beat the stress of travel and reach your flight on time."
  },
  {
    "name": "Chauffeur-driven taxi Surat to Mumbai Airport",
    "description": "Enjoy a stress-free journey from Surat to Mumbai Airport with our chauffeur-driven taxi service. Our professional drivers assist with your luggage and provide a safe, smooth ride in fully serviced vehicles. Perfect for VIPs, business travelers, and anyone looking for a premium travel experience with personalized attention."
  },
  {
    "name": "AC cab Surat to Mumbai Airport",
    "description": "Beat the heat and travel comfortably with our fully air-conditioned cabs from Surat to Mumbai Airport. Deva Cabs maintains a fleet of clean, sanitized vehicles equipped with efficient cooling systems, ensuring you remain comfortable throughout the journey regardless of weather conditions."
  },
  {
    "name": "Surat to Mumbai T2 cab hire",
    "description": "Book your taxi directly to Mumbai Airport’s T2 terminal with Deva Cabs. Our drivers are familiar with terminal layouts and provide timely drop-offs and pickups at Terminal 2, ensuring you catch your flights without any last-minute hassles."
  },
  {
    "name": "Surat to Mumbai Airport night taxi",
    "description": "Need a late-night or early-morning taxi from Surat to Mumbai Airport? Deva Cabs offers 24/7 night taxi services ensuring safe and reliable transfers regardless of the time. Our drivers are experienced in nighttime driving, providing peace of mind for your airport journey."
  },
  {
    "name": "Family cab Surat to Mumbai Airport",
    "description": "Travel comfortably with your family using our spacious and safe family cabs from Surat to Mumbai Airport. We provide vehicles with ample seating and luggage space, ensuring every member of your family enjoys a smooth and secure ride."
  },
  {
    "name": "Online taxi Surat to Mumbai Airport",
    "description": "Reserve your taxi from Surat to Mumbai Airport online with Deva Cabs’ easy-to-use booking platform. Choose your vehicle type, schedule your pickup time, and receive instant confirmation. Our digital booking system offers convenience and transparency for all your travel needs."
  },
  {
    "name": "Pre-booked cab Surat to Mumbai Airport",
    "description": "Avoid last-minute hassles by pre-booking your cab from Surat to Mumbai Airport with Deva Cabs. Our advance booking option guarantees vehicle availability, fixed fares, and timely pickups, ensuring a stress-free travel experience."
  },
  {
    "name": "Fast taxi Surat to Mumbai Airport",
    "description": "If you’re looking for a quick and efficient taxi from Surat to Mumbai Airport, Deva Cabs provides fast service with drivers skilled in navigating the best routes. Our priority is getting you to the airport safely and on time, even during peak traffic hours."
  }
],
"tableData": [
  ["Surat to Mumbai Airport Taxi", "-One-way taxi Surat to Mumbai Airport"],
  ["Cab booking Surat to Mumbai Airport", "-Affordable Surat to Mumbai Airport cab"],
  ["SUV taxi Surat to Mumbai Airport", "-Luxury car Surat to Mumbai Airport"],
  ["Surat to Mumbai Airport drop service", "-Chauffeur-driven taxi Surat to Mumbai Airport"],
  ["AC cab Surat to Mumbai Airport", "-Surat to Mumbai T2 cab hire"],
  ["Surat to Mumbai Airport night taxi", "-Family cab Surat to Mumbai Airport"],
  ["Online taxi Surat to Mumbai Airport", "-Pre-booked cab Surat to Mumbai Airport"],
  ["Fast taxi Surat to Mumbai Airport", ""]
],

whychoose: [
  {
    "WhyChooseheading": "Reliable Surat to Mumbai Airport Transfers",
    "WhyChoosedescription": "Traveling from Surat to Mumbai Airport requires timely and dependable transportation, especially for catching flights. Our taxi service guarantees prompt pickups and accurate scheduling to get you to the airport with time to spare. Whether it’s a domestic or international flight, you can rely on us for a seamless and stress-free travel experience from doorstep to terminal."
  },
  {
    "WhyChooseheading": "Comfortable and Well-Equipped Vehicles for Long Journeys",
    "WhyChoosedescription": "The distance between Surat and Mumbai Airport can take 4–6 hours, so comfort is essential. Our taxis are designed for long-distance travel with air conditioning, plush seating, and spacious interiors to ensure a relaxing ride. You’ll also have ample luggage space, clean cabin conditions, and the option to choose the type of vehicle that best fits your travel style and group size."
  },
  {
    "WhyChooseheading": "Experienced Drivers with Route Expertise",
    "WhyChoosedescription": "Our drivers are not only licensed and trained but also well-acquainted with the Surat-to-Mumbai route, including highway tolls, rest stops, and optimal traffic patterns. They ensure safe driving practices, follow all road safety norms, and are respectful of your personal space and preferences, giving you complete peace of mind during the journey."
  },
  {
    "WhyChooseheading": "Transparent and Competitive Pricing",
    "WhyChoosedescription": "We believe in fair and upfront pricing for every customer. Our Surat to Mumbai Airport taxi fares are competitively priced with zero hidden charges. You’ll receive a clear quote at the time of booking, including tolls, fuel, and driver fees—so you can plan your budget confidently and avoid surprises at the end of your trip."
  },
  {
    "WhyChooseheading": "24/7 Availability to Match All Flight Timings",
    "WhyChoosedescription": "Whether your flight is early in the morning, during peak hours, or late at night, our taxis are available around the clock. We operate 24/7 so you can book your cab according to your schedule without worrying about time constraints or service availability—even on holidays or weekends."
  },
  {
    "WhyChooseheading": "Simple Booking Process with Quick Confirmations",
    "WhyChoosedescription": "Booking a taxi from Surat to Mumbai Airport is simple and fast with our online platform or customer care support. You can schedule your ride in advance or request an urgent pickup. We offer real-time booking confirmations, flexible cancellation policies, and support through every step of your journey."
  },
  {
    "WhyChooseheading": "Safety-First Approach with Fully Maintained Vehicles",
    "WhyChoosedescription": "Safety is at the core of our service. All vehicles are routinely serviced, sanitized, and checked before each ride. From GPS tracking and seat belts to professional driving standards and 24/7 emergency support, we ensure that your long journey from Surat to Mumbai Airport is secure and worry-free."
  },
  {
    "WhyChooseheading": "Customer-Focused Service Tailored to Your Needs",
    "WhyChoosedescription": "Every traveler has different needs, and we adapt accordingly. Whether you're traveling with a child, an elderly family member, or carrying special equipment, we offer tailored services to enhance your comfort. Our drivers are courteous, helpful, and committed to providing a smooth, personalized experience from start to finish."
  }
]
















    }










const faqData = [
  {
    question: "Can I book a taxi from Surat to Mumbai Airport with Deva Cabs?",
    answer: "Yes, Deva Cabs offers reliable taxi services from Surat to Mumbai Airport, available for both domestic and international flights."
  },
  {
    question: "How long does it take to travel from Surat to Mumbai Airport by taxi?",
    answer: "The journey typically takes around 5 to 6 hours depending on traffic and road conditions."
  },
  {
    question: "What types of taxis are available for the Surat to Mumbai Airport route?",
    answer: "We provide a range of vehicles including sedans, SUVs, Ertiga, Innova Crysta, and tempo travellers for group travel."
  },
  {
    question: "Can I pre-book a taxi from Surat to Mumbai Airport?",
    answer: "Absolutely. You can pre-book your taxi via our website, app, or by contacting our customer support for scheduled pickups."
  },
  {
    question: "Are one-way taxi services available from Surat to Mumbai Airport?",
    answer: "Yes, Deva Cabs offers convenient and affordable one-way taxi services without return fare charges."
  },
  {
    question: "Are toll and parking charges included in the fare?",
    answer: "Toll and parking charges are generally extra and will be transparently communicated during booking."
  },
  {
    question: "Is the taxi service available at night or early morning?",
    answer: "Yes, our taxi service operates 24/7 to accommodate flights at any time."
  },
  {
    question: "Is it safe to travel from Surat to Mumbai Airport by taxi?",
    answer: "Yes, our drivers are background-verified and trained to ensure your safety and comfort throughout the journey."
  },
  {
    question: "Will the driver wait if my flight is delayed?",
    answer: "Yes, our drivers monitor flight timings and adjust pickup accordingly to avoid inconvenience."
  },
  {
    question: "Why choose Deva Cabs for Surat to Mumbai Airport taxi service?",
    answer: "Deva Cabs offers professional drivers, clean vehicles, transparent pricing, and reliable service for a hassle-free trip."
  }
];

const testimonialData = [
  {
    id: 21,
    name: 'Mr. Kiran Patel',
    role: 'Business Traveler',
    review: 'Booked a taxi from Surat to Mumbai Airport with Deva Cabs. The driver was punctual and courteous, and the ride was very comfortable.',
    rating: 5,
    quoteIcon: '/img/icon/testi-quote.svg',
  },
  {
    id: 22,
    name: 'Ms. Neha Shah',
    role: 'Frequent Flyer',
    review: 'Deva Cabs made my trip from Surat to Mumbai Airport hassle-free. Excellent service and professional drivers. Highly recommend!',
    rating: 5,
    quoteIcon: '/img/icon/testi-quote.svg',
  }
];

































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 8108807171",
            "+91 9764227171",



        ],
        email: "booking@devacab.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Cab Service in Mumbai",
            link: "/Cab-Service-in-Mumbai"
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Cab Service in Navi Mumbai",
            link: "/Cab-Service-in-Navi-Mumbai"
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Cab Service in Thane",
            link: "/Cab-Service-in-Thane"
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Cab Service Near Me Mumbai",
            link: "/Cab-Service-Near-Me-Mumbai"
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Car Rental in Mumbai",
            link: "/Car-Rental-in-Mumbai"
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Corporate Cab Services in Mumbai",
            link: "/Corporate-Cab-Services-in-Mumbai"
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Online Taxi Booking Mumbai",
            link: "/Online-Taxi-Booking-Mumbai"
        },
        {
            place: "/images/keyword/8.jpg",
            text: "Wedding Car Rental Mumbai",
            link: "/Wedding-Car-Rental-Mumbai"
        },
        {
            place: "/images/keyword/9.jpg",
            text: "Tempo Traveller on Rent in Mumbai",
            link: "/Tempo-Traveller-on-Rent-in-Mumbai"
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Innova Crysta on Rent in Mumbai",
            link: "/Innova-Crysta-on-Rent-in-Mumbai"
        },
        {
            place: "/images/keyword/11.jpg",
            text: "Ertiga on Rent in Mumbai",
            link: "/Ertiga-on-Rent-in-Mumbai"
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Mini Bus on Rent in Mumbai",
            link: "/Mini-Bus-on-Rent-in-Mumbai"
        },
        {
            place: "/images/keyword/13.jpg",
            text: "Mumbai Airport Cab Booking",
            link: "/Mumbai-Airport-Cab-Booking"
        },
        {
            place: "/images/keyword/14.jpg",
            text: "Navi Mumbai Car Rental Service",
            link: "/Navi-Mumbai-Car-Rental-Service"
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Mumbai Airport to Pune Cab",
            link: "/Mumbai-Airport-to-Pune-Cab"
        },
        {
            place: "/images/keyword/16.jpg",
            text: "Mumbai Airport to Shirdi Taxi",
            link: "/Mumbai-Airport-to-Shirdi-Taxi"
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Pune to Mumbai Airport Cab",
            link: "/Pune-to-Mumbai-Airport-Cab"
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Pune Airport to Mumbai Cab",
            link: "/Pune-Airport-to-Mumbai-Cab"
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Surat to Mumbai Airport Taxi",
            link: "/Surat-to-Mumbai-Airport-Taxi"
        },
        {
            place: "/images/keyword/20.jpg",
            text: "Nashik to Mumbai Airport Cab",
            link: "/Nashik-to-Mumbai-Airport-Cab"
        },
        {
            place: "/images/keyword/21.jpg",
            text: "Mumbai to Nashik Cab",
            link: "/Mumbai-to-Nashik-Cab"
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Mumbai to Shirdi Cab",
            link: "/Mumbai-to-Shirdi-Cab"
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Mumbai to Lonavala Cab",
            link: "/Mumbai-to-Lonavala-Cab"
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Mumbai to Khandala Cab",
            link: "/Mumbai-to-Khandala-Cab"
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Mumbai to Lavasa Cab",
            link: "/Mumbai-to-Lavasa-Cab"
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Mumbai to Matheran Cab",
            link: "/Mumbai-to-Matheran-Cab"
        }
    ];



    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },

    ];



const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Surat to Mumbai Airport Taxi",
  "image": "https://devacab.com/assets/images/surat-to-mumbai-airport-taxi.jpg", // Replace with actual image URL
  "description": "Book affordable and reliable Surat to Mumbai Airport taxi service with Deva Cabs. Choose from AC, SUV, luxury, and chauffeur-driven cabs for one-way and night transfers with easy online booking.",
  "brand": {
    "@type": "Brand",
    "name": "Deva Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "1200"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "4800",
    "availability": "https://schema.org/InStock",
    "url": "https://devacab.com/surat-to-mumbai-airport-taxi" // Replace with actual page URL
  }
};





    return (
        <div>
<GoogleTagManager/>
<Helmet>
  <title>Surat to Mumbai Airport Taxi | Affordable & Luxury Cab Service | Deva Cabs</title>
  <meta 
    name="description" 
    content="Book Surat to Mumbai Airport taxi with Deva Cabs. AC, SUV, luxury, and chauffeur-driven cabs available for one-way and night transfers. Fast and affordable with online booking." 
  />
  <meta 
    name="keywords" 
    content="Surat to Mumbai Airport Taxi, One-way taxi Surat to Mumbai Airport, Cab booking Surat to Mumbai Airport, Affordable Surat to Mumbai Airport cab, SUV taxi Surat to Mumbai Airport, Luxury car Surat to Mumbai Airport, Surat to Mumbai Airport drop service, Chauffeur-driven taxi Surat to Mumbai Airport, AC cab Surat to Mumbai Airport, Surat to Mumbai T2 cab hire, Surat to Mumbai Airport night taxi, Family cab Surat to Mumbai Airport, Online taxi Surat to Mumbai Airport, Pre-booked cab Surat to Mumbai Airport, Fast taxi Surat to Mumbai Airport" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


            <div className="breadcumb-wrapper" >
                <div className="container">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                    </div>
                </div>
            </div>



            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/19.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#F8911B', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                // padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolor">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    // padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolor">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className=''>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Deva Cabs</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">


                                                <FAQ faqData={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialKeyword testimonialData={testimonialData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1" key={e.text}>
                                        <a
                                            href={e.link} // Use the separate link for each item
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt={e.text} />
                                            </div>
                                            <div className="b2">
                                                <a href={e.link} className="px-3 colorr">{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #562018',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#562018' }}>
                                            <h4 className=" lead fw-semibold whitt text-white bg-ora">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+91 8108807171" className="d-block  text-white">+91 8108807171</a>
                                                <a href="tel:+91 9764227171" className="d-block  text-white">+91 9764227171</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#562018' }}>
                                                <h4 className=" fw-semibold lead whitt text-white bg-ora">Email</h4>
                                                <a href="mailto:booking@devacab.com" className=" text-white d-block">
                                                    booking@devacab.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#562018' }}>
                                                <h4 className=" fw-semibold lead whitt text-white bg-ora">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Deva Cabs<br />
                                                        SS-2 404 Sector -17 Behind Mother India School Koparkhairne Navi Mumbai 400709
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </section>

        </div>
    );
}

export default Surattomumbaiairporttaxi;